import type { Customer, Media } from "@mw/shared/payload-types";

import { isEntity } from "@utilities/payload";

import type { LogoConfig } from "@/app/_components/ContactSales/LogoSlider";

export type { LogoConfig };

type LogoEntry = {
  customer?: Customer | string | null;
};

/**
 * Resolves an array of customer relationship entries into LogoConfig[]
 * for rendering in the LogoSlider component.
 * Requires populated customer entities (depth >= 2).
 */
export function resolveCustomerLogos(logos: LogoEntry[] | null | undefined): LogoConfig[] {
  if (!logos?.length) return [];
  return logos
    .map(entry => {
      const customer = entry.customer;
      if (!customer || !isEntity(customer)) return null;
      const c = customer as Customer;
      const logoMedia = c.logoGridImage;
      if (!logoMedia || !isEntity(logoMedia)) return null;
      const img = logoMedia as Media;
      if (!img.url || !img.width || !img.height) return null;
      const scale = 40 / img.height;
      return {
        height: 40,
        width: Math.round(img.width * scale),
        src: img.url,
        alt: c.name,
      };
    })
    .filter((l): l is LogoConfig => l !== null);
}
